import { render, staticRenderFns } from "./AddPricePolicyModal.vue?vue&type=template&id=1f709df4&scoped=true&"
import script from "./AddPricePolicyModal.vue?vue&type=script&lang=js&"
export * from "./AddPricePolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f709df4",
  null
  
)

export default component.exports